// v-number-limit.ts
import type { DirectiveBinding } from 'vue'

function formatInput(value: string, decimalPlaces: number): string {
  value = value.replace(/[^0-9.]/g, '')
  const parts = value.split('.')

  if (decimalPlaces === 0) {
    return parts[0]
  }

  // 限制只有一个小数点
  if (parts.length > 2) {
    value = `${parts[0]}.${parts.slice(1).join('')}`
  }

  // 限制小数位数
  if (parts[1] && parts[1].length > decimalPlaces) {
    value = `${parts[0]}.${parts[1].slice(0, decimalPlaces)}`
  }

  return value
}

function handleInput(event: Event, decimalPlaces: number): void {
  const input = event.target as HTMLInputElement
  const formattedValue = formatInput(input.value, decimalPlaces)

  if (input.value !== formattedValue) {
    input.value = formattedValue

    const s = setTimeout(() => {
      input.dispatchEvent(new Event('input', { bubbles: true }))
      clearTimeout(s)
    }, 0)
  }
}

export default {
  beforeMount(el: HTMLInputElement, binding: DirectiveBinding) {
    try {
      const decimalPlaces = (binding.value || binding.value === 0) ? binding.value : 2

      el._decimalPlaces = decimalPlaces

      const onInput = (event: Event) => handleInput(event, el._decimalPlaces)
      el.addEventListener('input', onInput)

      // 在 el 上保存事件处理器，方便后续更新时移除
      el._onInput = onInput
    } catch (err) {
      console.log(err)
    }
  },

  updated(el: HTMLInputElement, binding: DirectiveBinding) {
    const decimalPlaces = (binding.value || binding.value === 0) ? binding.value : 2
    if (el._decimalPlaces !== decimalPlaces) {
      el.removeEventListener('input', el._onInput)
      el._decimalPlaces = decimalPlaces
      const onInput = (event: Event) => handleInput(event, el._decimalPlaces)
      el.addEventListener('input', onInput)
      el.value = formatInput(el.value, decimalPlaces)
      el.dispatchEvent(new Event('input', { bubbles: true }))
      el._onInput = onInput
    }
  },

  unmounted(el: HTMLInputElement) {
    // 移除事件监听器
    el.removeEventListener('input', el._onInput)
  },
}
